<template>
  <div class="pl-48 items-stretch">
    <button :disabled="enableButton" v-for="(header, i) in tabs" :key="i" class="flex-grow rounded-lg px-6 py-3 border-2 mr-2 relative" :class="header.id === activeTab ? 'bg-tertiary border-tertiary text-white active' : 'bg-white border-transparent hover:border-grey cursor-pointer'" @click="changeValue(header.id)">
      <div v-if="header.icon">
        <i class="fa" :class="`fa-${header.icon}`"></i>
      </div>
      {{ header.title }}
      <span v-if="header.badge && header.badge > 0 && (header.id !== 'automatic' || potentialReferralCount > 0)" class="absolute text-center text-xs rounded-full bg-red-dark text-white h-5 w-5 shadow" style="top: -8px; right: -8px; line-height: 20px;">
        {{ header.id !== 'automatic' ? (header.badge > 99 ? '99+' : header.badge) : potentialReferralCount }}
      </span>

    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'tabulatedControls',
  model: {
    prop: 'active',
    event: 'change'
  },
  props: [
    'tabs',
    'active',
    'disableButton'
  ],
  data () {
    return {
      activeTab: this.active
    }
  },
  watch: {
    active () {
      this.activeTab = this.active
    }
  },
  methods: {
    changeValue (id) {
      this.activeTab = id
      this.$emit('change', id)
    }
  },
  computed: {
    ...mapState(['potentialReferralCount']),
    enableButton () {
      if (this.disableButton === true) {
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.active::after {
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #fff;
    border-top-color: rgb(255, 255, 255);
  content: "";
  left: 50%;
  position: absolute;
  top: 100%;
  z-index: 1;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  border-top-color: inherit;
}
</style>
